import { Skeleton } from 'components/ui';

/**
 *
 * @param {{color:"graph_1" | "graph_2" | "graph_3" | "graph_4" | "gray",
 * label:string,
 * highlightValue:string,
 * referenceValue?:string,
 * loading:boolean }} param0
 * @returns
 */
export default function LabelItem({
  color,
  label,
  highlightValue,
  referenceValue,
  loading,
}) {
  const classes = {
    graph_1: {
      background: 'bg-segments-graph-color-1',
      text: 'text-segments-graph-color-1',
    },
    graph_2: {
      background: 'bg-segments-graph-color-2',
      text: 'text-segments-graph-color-2',
    },
    graph_3: {
      background: 'bg-segments-graph-color-3',
      text: 'text-segments-graph-color-3',
    },
    graph_4: {
      background: 'bg-segments-graph-color-4',
      text: 'text-segments-graph-color-4',
    },
    gray: {
      background: 'bg-segments-disabled-field',
      text: 'text-segments-disabled-field',
    },
  };

  return (
    <div>
      <div className="flex items-center space-x-2">
        <div className={`w-3 h-3 rounded-full ${classes[color]?.background}`} />
        <p className={`font-bold text-segments-13px ${classes[color]?.text}`}>
          {label}
        </p>
      </div>
      <Skeleton isLoaded={!loading}>
        <p className="mt-1.5 ml-5 text-2xl leading-7">{highlightValue}</p>
      </Skeleton>

      {referenceValue && (
        <Skeleton isLoaded={!loading}>
          <p className="ml-5 font-bold text-black text-opacity-50 text-segments-13px mt-0.5">
            {referenceValue}
          </p>
        </Skeleton>
      )}
    </div>
  );
}
